import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const reset = ({ commit }) => {
  commit(types.LINK_CREATE_RESET);
};

export const create = ({ commit }, values) => {
  commit(types.LINK_CREATE_SET_ERROR, "");
  commit(types.LINK_CREATE_TOGGLE_LOADING);
  axios
    .post(URL_BACKEND + "api-rob/addLink/", values.values)
    .then((response) => {
      commit(types.LINK_CREATE_SET_CREATED, true);
      commit(types.LINK_CREATE_TOGGLE_LOADING);
      values.item.id = response.data.id;
    })
    .catch((e) => {
      commit(types.LINK_CREATE_TOGGLE_LOADING);
      commit(types.LINK_CREATE_SET_ERROR, e.message);
    });
};
